import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';

import { SingleInput } from '../../Res/BaseInput';
export const ContractorAttendanceDailogOvertimePay = forwardRef((props, ref)=>{
    const [OvertimePay, setOvertimePay] = useState(0)

    useEffect(() => {
        if (props.obj !== undefined && props.obj !== OvertimePay) {
            setOvertimePay(props.obj)
        }
    }, [props.obj])

    // useEffect(()=>{
    //     console.log(props)
    // })

    useImperativeHandle(ref, () => ({
        send: () => {
            props.action({OvertimePay})
        }
      }));
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-6">項目名稱</th>
                    <th className="text-right sorting col-sm-6">金額</th>
                </tr>
                <tr role="row">
                    <td className="text-center">加班總金額</td>
                    <td className="text-right">
                        <SingleInput val={OvertimePay} action={setOvertimePay} placeholder={176} size={6} type={"number"} />
                    </td>
                </tr>
            </thead>
        </table>
    )
})